const SvgSecure4 = (props) => (
  <>
    <path
      d="M16 384c0-44.18 35.82-80 80-80s80 35.82 80 80H16ZM16 304c0-44.18 35.82-80 80-80s80 35.82 80 80H16ZM16 224c0-44.18 35.82-80 80-80s80 35.82 80 80H16ZM16 144c0-44.18 35.82-80 80-80s80 35.82 80 80H16Z"
      fill={props.p20}
      opacity={0.5}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M96 0v64" />
    <path
      d="M174.99 65c-.54 43.1-35.77 78-78.99 78s-78.45-34.9-78.99-78H175m1.01-1H16c0 44.18 35.82 80 80 80s80-35.82 80-80ZM174.99 145c-.54 43.1-35.77 78-78.99 78-43.23 0-78.45-34.9-78.99-78H175m1.01-1H16c0 44.18 35.82 80 80 80s80-35.82 80-80ZM174.99 225c-.54 43.1-35.77 78-78.99 78-43.23 0-78.45-34.9-78.99-78H175m1.01-1H16c0 44.18 35.82 80 80 80s80-35.82 80-80ZM174.99 305c-.54 43.1-35.77 78-78.99 78-43.23 0-78.45-34.9-78.99-78H175m1.01-1H16c0 44.18 35.82 80 80 80s80-35.82 80-80Z"
      fill={props.p50}
    />
    <circle cx={96} cy={144} r={4} fill={props.p50} />
    <circle cx={96} cy={64} r={4} fill={props.p50} />
    <circle cx={96} cy={224} r={4} fill={props.p50} />
    <circle cx={96} cy={304} r={4} fill={props.p50} />
  </>
);

export default SvgSecure4;
